import httpService from '../../utils/httpService';
import {
  SET_LIST_ALL_USER,
  SET_LIST_DEVICE_TO_USER,
  REMOVE_ALL_STATE,
  SET_INFO_AN_USER,
  SET_USER_PROFILE
} from '../mutation-types';

import mixins from '../../mixins/mixins';
import authen from '../../utils/authen';
import store from '@/store';
import router from '../../router';
import Vue from 'vue';

const initState = () => {
  return {
    $listAllUser: [],
    $listAllUserByArea: [],
    $infoAnUser: [],
    $infoAnUserByArea: [],
    $listArea: [
      { value: "Camera thủy điện" },
      { value: "Camera thủy lợi" },
      { value: "Camera đê điều" },
      { value: "Camera vùng nguy hiểm, sạt lở" },
      { value: "Camera vùng ngập lụt" },
      { value: "Camera khu neo đậu" },
      { value: "Loại camera khác" },
    ],
    $listEvents: [],
    $userProfile: {},
    token: ''
  };
};

const mapDevice = {
  state: {
    $listAllUser: initState().$listAllUser,
    $listAllUserByArea: initState().$listAllUserByArea,
    $infoAnUser: initState().$infoAnUser,
    $infoAnUserByArea: initState().$infoAnUserByArea,
    token: authen.getToken(),
    $listArea: initState().$listArea,
    $listEvents: initState().$listEvents,
    $userProfile: initState(). $userProfile
  },

  getters: {
    $listAllUser: state => state.$listAllUser,
    $listAllUserByArea: state => state.$listAllUserByArea,
    $infoAnUser: state => state.$infoAnUser,
    $infoAnUserByArea: state => state.$infoAnUserByArea,
    $listArea: state => state.$listArea,
    $listEvents: state => state.$listEvents,
    $userProfile: state => state.$userProfile
  },

  mutations: {
    SET_LIST_ALL_USER_BY_AREA (state, payload) {
      state.$listAllUser.forEach(function (element) {
        let listDeviceByArea = element.listDevices.reduce((arrs, item) => {
          let idx = arrs.findIndex(el => el.area === item[0].area);
          if (idx < 0) {
            let obj = {};
            obj.area = item[0].area;
            obj.listDevices = [item];
            arrs.push(obj);
          } else {
            arrs[idx].listDevices.push(item);
          }
          return arrs;
        }, []);
        let obj = {};
        obj.username = element.usr;
        obj.permission = element.role;
        obj.listDeviceByArea = listDeviceByArea || {};
        state.$listAllUserByArea.push(obj);
      });
    },

    SET_INFO_AN_USER_BY_AREA (state, payload) {
      state.$infoAnUser.forEach(function (element) {
        let listDeviceByArea = element.listDevices.reduce((arrs, item) => {
          let idx = arrs.findIndex(el => el.area === item[0].area);
          if (idx < 0) {
            let obj = {};
            obj.area = item[0].area;
            obj.listDevices = [item];
            arrs.push(obj);
          } else {
            arrs[idx].listDevices.push(item);
          }
          return arrs;
        }, []);
        let obj = {};
        obj.username = element.username;
        obj.listDeviceByArea = listDeviceByArea || {};
        state.$infoAnUserByArea.push(obj);
      });
    },

    RESET_USER_BY_AREA (state) {
      state.$listAllUserByArea = initState().$listAllUserByArea;
      state.$listAllUser = initState().$listAllUser;
      state.$infoAnUserByArea = initState().$infoAnUserByArea;
      state.$infoAnUser = initState().$infoAnUser;
    },

    [SET_LIST_ALL_USER] (state, payload) {
      state.$listAllUser = Object.values(payload);
    },

    [SET_INFO_AN_USER] (state, payload) {
      state.$infoAnUser = Object.values(payload);
    },
    [SET_USER_PROFILE] (state, payload) {
      state.$userProfile = payload;
    },
    CHANGE_INFO_USER (state, payload) {
      state.$infoAnUser[0].listDevices.forEach(device => {
        payload.forEach(item => {
          item[0].id === device[0].id ? device.Monitor_Status = JSON.parse(JSON.stringify(item.Monitor_Status)) : '';
        });
      });
    },
    CHANGE_LIST_USER (state, payload) {
      // state.$listAllUser.forEach(item => {
      //   item.listDevices.forEach(device => {
      //     payload.forEach(item => {
      //       item[0].id === device[0].id ? device.Monitor_Status = JSON.parse(JSON.stringify(item.Monitor_Status)) : '';
      //     });
      //   });
      // })
    },

    [SET_LIST_DEVICE_TO_USER] (state, payload) {
      let index = state.$listAllUser.findIndex(
        item => item.usr === payload.username
      );
      new Vue().$set(state.$listAllUser[index], 'listDevices', [].concat(payload.result));
      // state.$listAllUser[index].listDevices = [].concat(payload.result);
      // payload.isLastItem && store.commit('SET_LIST_ALL_USER_BY_AREA');
    },

    [REMOVE_ALL_STATE] (state, payload) {
      state.$infoAnUser = initState().$infoAnUser;
      state.$infoAnUserByArea = initState().$infoAnUserByArea;
      state.$listAllUser = initState().$listAllUser;
      state.$listAllUserByArea = initState().$listAllUserByArea;
      state.token = initState().token;
    },

    REDIRECT_TO_LOGIN (state, payload) {
      mixins.methods.removeInfoUser();
      router.push({ name: 'login' });
    },

    setListAreaDevice (state, payload) {
      state.$listArea = initState().$listArea;
      payload.filter(item => item !== null)
        .forEach((item, idx) => {
          let config = {
            index: idx,
            value: item
          };
          new Vue().$set(state.$listArea, idx, config);
        });
    },

    setListEvents (state, payload) {
      if (payload.type === 'push') {
        state.$listEvents.push(...payload.data);
      } else {
        state.$listEvents = payload.data;
      }
    }
  },

  actions: {
    LOAD_LIST_ALL_USER ({ commit, dispatch, state }, payload) {
      httpService.methods
        .$get('api/getListUser')
        .then(async res => {
          if (res === 'Token không hợp lệ') {
            this.$store.dispatch('SET_START_LOADING_ALL_SCREEN');
            this.removeInfoUser();
            this.$router.push({name: 'login'});
            this.$store.dispatch('SET_STOP_LOADING_ALL_SCREEN');
          } else
          if (typeof res === 'string') {
            commit('REDIRECT_TO_LOGIN');
          } else {
            let listDevices = [];
            commit(SET_LIST_ALL_USER, res);
            await dispatch('LOAD_ALL_DEVICE')
              .then(res => {
                if (typeof res === 'object') {
                  listDevices = Object.values(res).filter(item => item[0]);
                }
              });
            for (const user of state.$listAllUser) {
              commit('SET_LIST_DEVICE_TO_USER', {
                username: user.usr,
                result: listDevices.filter(item => user.role === 'admin' ? item[0].id : user.listDevice ? user.listDevice.includes(item[0].id) : false)
              });
            }
            store.dispatch('LOAD_ALL_AREA_DEVICE');
            commit('SET_LIST_ALL_USER_BY_AREA');
          }
        });
    },
    LOAD_ALL_DEVICE ({ dispatch, state, commit }, payload) {
      return httpService.methods.$get('api/listDeviceInfo');
    },
    SET_INFO_AN_USER ({ dispatch, state, commit }, payload) {
      store.commit('SET_START_LOADING_MAIN_SCREEN');
      dispatch('LOAD_ALL_DEVICE')
        .then(result => {
          commit('SET_INFO_AN_USER', {
            0: {
              username: authen.get('vms_username'),
              listDevices: Object.values(result).filter(item => item[0])
            }
          });
          store.dispatch('LOAD_ALL_AREA_DEVICE');
          store.commit('SET_INFO_AN_USER_BY_AREA');
        })
        store.commit('SET_STOP_LOADING_MAIN_SCREEN');
    },
    CHANGE_INFO_USER (state, payload) {
      store.commit('CHANGE_INFO_USER', payload);
    },
    LOAD_PROFILE(state, payload) {
      return httpService.methods.$get('api/getInfoUser');
    },
    SET_USER_PROFILE ({dispatch, state, commit}, payload) {
      dispatch('LOAD_PROFILE').then(res => {
        if (res.success === true) {
          commit('SET_USER_PROFILE', res);
        }
      });
    },
    CHANGE_LIST_USER (state, payload) {
      store.commit('CHANGE_LIST_USER');
    },
    LOAD_DETAIL_DEVICE (state, payload) {
      return httpService.methods.$get(
        `api/deviceInfo/${payload.deviceId}`);
    },

    ADD_DEVICE_USER ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'AdminAddDevice',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: payload.token,
          area: payload.area,
          username: payload.username
        })
      );
    },

    ADD_DEVICE_ADMIN ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'AddDevice',
        JSON.stringify({
          device_id: payload.device_id,
          // area: payload.area,
          tokenkey: payload.token
        })
      );
    },

    REMOVE_DEVICE_ADMIN ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DeleteDevice',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: payload.tokenUser
        })
      );
    },

    REMOVE_DEVICE_USER ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'AdminDeleteDevice',
        JSON.stringify({
          device_id: payload.device_id,
          username: payload.username,
          tokenkey: payload.tokenUser
        })
      );
    },

    ADD_USER ({ commit, dispatch, state }, payload) {
      return httpService.methods.$post(
        'api/signup',
        JSON.stringify({
          usr: payload.user,
          pwd: payload.pwd,
          role: payload.role,
          info: payload.info
        })
      );
    },

    CHANGE_PASSWORD_USER ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'api/changePassword',
        JSON.stringify({
          usr: payload.username,
          oldPwd: payload.password,
          newPwd: payload.NewPassword
        })
      );
    },

    REMOVE_USER ({ commit, dispatch, state }, payload) {
      return httpService.methods.$post(
        'DeleteUsers',
        JSON.stringify({
          tokenkey: authen.getToken(),
          username: payload.username
        })
      );
    },

    READ_SENSOR_IN_DAY ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataApi/ReadDeviceData',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: payload.tokenUser,
          year: payload.year,
          month: payload.month,
          day: payload.day
        })
      );
    },

    READ_ONE_SENSOR_IN_DAY ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataApi/ReadDeviceDataByDayInput',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: payload.tokenUser,
          year: payload.year,
          month: payload.month,
          day: payload.day,
          numInput: payload.numberSensor
        })
      );
    },

    CONFIG_DEVICE_ADMIN ({ commit, dispatch, state }, payload) {
      return httpService.methods.$post(
        'DeviceChangeAdmin',
        JSON.stringify({
          device_id: payload.deviceId,
          tokenkey: authen.getToken(),
          newdevicename: payload.newName,
          latitude: payload.lat,
          longitude: payload.lng,
          area: payload.area
        })
      );
    },

    CONFIG_DEVICE_USER ({ comit, dispatch, state }, payload) {
      return httpService.methods.$post(
        'DeviceChangeUser',
        JSON.stringify({
          device_id: payload.deviceId,
          tokenkey: authen.getToken(),
          newdevicename: payload.newName,
          latitude: payload.lat,
          longitude: payload.lng,
          config: payload.config,
          area: payload.area
        })
      );
    },

    LOAD_ALL_AREA_DEVICE ({ commit, dispatch, state }, payload) {
      var listArea = []
      if (authen.get('vms_role') !== 'admin') {
        state.$infoAnUser[0].listDevices.forEach(monitor => {
          if (!listArea.includes(monitor[0].area) && monitor[0].area !== "") {
            listArea.push(monitor[0].area);
          }
        });
      } else {
        state.$listAllUser[0].listDevices.forEach(monitor => {
          if (!listArea.includes(monitor[0].area) && monitor[0].area !== "") {
            listArea.push(monitor[0].area);
          }
        });
      }
      // commit('setListAreaDevice', listArea);
    },

    LOAD_DATA_TOTAL_LOST ({ commit, dispatch, state }, payload) {
      return httpService.methods.$post(
        'DataApi/LossByHour',
        JSON.stringify({
          device_id: payload.deviceId,
          tokenkey: authen.getToken(),
          year: payload.year,
          day: payload.day,
          month: payload.month,
          numInput: payload.numInput
        })
      );
    },

    LOAD_LIST_EVENTS ({ commit, dispatch }, payload) {
      httpService.methods
        .$post(
          'DataApi/EventLoad',
          JSON.stringify({ tokenkey: authen.getToken() })
        )
        .then(res => {
          commit('setListEvents', { type: 'new', data: res });
        });
    },

    GET_EVENT_NEWEST ({ commit, dispatch }) {
      return httpService.methods.$post(
        'DataApi/EventLive',
        JSON.stringify({ tokenkey: authen.getToken() })
      );
    },

    ADMIN_RESET_PASSWORD_USER ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'AdminResetPassword',
        JSON.stringify({
          tokenkey: authen.getToken(),
          username: payload.username,
          newpassword: payload.newpassword
        })
      );
    },

    SEND_REQ_GET_SIM_INFO ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataApi/checkSimInfo',
        JSON.stringify({
          tokenkey: authen.getToken(),
          device_id: payload.deviceId
        })
      );
    },

    RECEIVE_SIM_INFO ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataApi/SimInfo',
        JSON.stringify({
          tokenkey: authen.getToken(),
          device_id: payload.deviceId
        })
      );
    },

    FILTER_EVENT_BY_RANGETIME ({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataApi/findlog',
        JSON.stringify({
          tokenkey: authen.getToken(),
          year: payload.year,
          end_day: payload.end_day,
          end_month: payload.end_month,
          start_day: payload.start_day,
          start_month: payload.start_month,
          numberPage: payload.numberPage
        })
      );
    }
  }
};

export default mapDevice;



// WEBPACK FOOTER //
// ./src/store/modules/mapDevice.js